(function() {

	let mustPrevent = true;

	const form  = document.getElementsByClassName("js-form");
	for (let i = 0; i < form.length; i++) {
		form[i].addEventListener("submit", function() {
			mustPrevent = false;
		});
	}

	const allowLeave = document.getElementsByClassName("js-allow-leave");
	for (let i = 0; i < allowLeave.length; i++) {
		allowLeave[i].addEventListener("click", function() {
			mustPrevent = false;

		});
	}
	
	window.addEventListener('beforeunload', e => {

		if (mustPrevent) {

			return e.returnValue = "Are you sure you want to exit?";
		}
		else {
			return undefined;
		}
	});

})()